export const ClaimEventTypes = {
  /**
   * NOTE: For LGM only
   */
  SIGNED_NOTICE_OF_PROBABLE_LOSS_FORM_RECEIVED:
    'SIGNED_NOTICE_OF_PROBABLE_LOSS_FORM_RECEIVED',

  /**
   * NOTE: For LRP only
   */
  SIGNED_ENDING_VALUE_FORM_RECEIVED: 'SIGNED_ENDING_VALUE_FORM_RECEIVED',
  SALES_RECEIPTS_RECEIVED: 'SALES_RECEIPTS_RECEIVED',
  SIGNED_RETAINED_OWNERSHIP_FORM_RECEIVED:
    'SIGNED_RETAINED_OWNERSHIP_FORM_RECEIVED',
  DOCUMENTS_AND_SIGNATURES_COLLECTED: 'DOCUMENTS_AND_SIGNATURES_COLLECTED',
  CLAIMS_PACKET_SUBMITTED: 'CLAIMS_PACKET_SUBMITTED',
  CHECK_MAILED: 'CHECK_MAILED',
} as const;

export type ClaimEventType =
  (typeof ClaimEventTypes)[keyof typeof ClaimEventTypes];
